import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  FaHome,
  FaInfoCircle,
  FaFileAlt,
  FaUserMd,
  FaHandshake,
  FaUsers,
  FaQuestionCircle,
  FaSignOutAlt,
  FaBars,
  FaTimes
} from "react-icons/fa"; 
import "../styles/Sidebar.css";
import logo from "../images/logo login.svg";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [lastPath, setLastPath] = useState(window.location.pathname);
  const navigate = useNavigate();
  const location = useLocation();

  // Detecta mudança de tamanho da tela
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Detecta ao montar se deve iniciar como mobile
  useEffect(() => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    if (mobile) {
      setCollapsed(true);
    }
  }, []);

  // Fecha a sidebar somente quando a rota muda no mobile
  useEffect(() => {
    if (isMobile && location.pathname !== lastPath) {
      setCollapsed(true);
      setLastPath(location.pathname);
    }
  }, [location.pathname, isMobile, lastPath]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    console.log("Collapsed agora:", !collapsed);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const sidebarClass = [
    "sidebar",
    isMobile ? "mobile" : "desktop",
    collapsed ? "collapsed" : "expanded"
  ].join(" ");

  return (
    <>
      {isMobile && (
        <button 
          className="menu-toggle" 
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          {collapsed ? <FaBars /> : <FaTimes />}
        </button>
      )}
      
      <nav className={sidebarClass} id="sidebar">
        <div className="sidebar-header">
          {!collapsed && <img src={logo} alt="Logo Cronus" />}
          {!isMobile && (
            <button id="toggle-btn" onClick={toggleSidebar} aria-label="Toggle sidebar">
              &#9776;
            </button>
          )}
        </div>
        
        <ul className="list-unstyled components">
          <li>
            <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaHome className="icon" />
              {!collapsed && <span className="nav-text">Início</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/profile" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaInfoCircle className="icon" />
              {!collapsed && <span className="nav-text">Suas Informações</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/relatorios" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaFileAlt className="icon" />
              {!collapsed && <span className="nav-text">Relatórios</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/pacientes" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaUserMd className="icon" />
              {!collapsed && <span className="nav-text">Pacientes</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/parceiros" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaHandshake className="icon" />
              {!collapsed && <span className="nav-text">Parceiros</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/social" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaUsers className="icon" />
              {!collapsed && <span className="nav-text">Social</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaQuestionCircle className="icon" />
              {!collapsed && <span className="nav-text">Sobre</span>}
            </NavLink>
          </li>
        </ul>
        
        <div className="logout">
          <button onClick={handleLogout}>
            <FaSignOutAlt className="icon" />
            {!collapsed && <span className="nav-text">Sair</span>}
          </button>
        </div>
      </nav>
      
      {isMobile && !collapsed && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </>
  );
};

export default Sidebar;
